export default "__VITE_ASSET__BtoBD5cu__"